import type { Group, CreateGroup, UpdateGroup } from "@/types/group/group";

export enum AccountStatus {
	Active = "active",
	Inactive = "inactive",
	Suspended = "suspended",
}

export interface Account {
	id: string;
	main_account_id: string;
	main_account_display_name: string;
	display_name: string;
	logo_url: string;
	org_number: string;
	contact_name: string;
	email: string;
	phone_nr: string;
	status: AccountStatus;
	groups: Group[];
}

export interface CreateAccount {
	display_name: string;
	org_number: string;
	contact_name: string;
	email: string;
	phone_nr: string;
	groups: CreateGroup[];
}

export interface UpdateAccount {
	id: string;
	display_name: string;
	org_number: string;
	contact_name: string;
	email: string;
	phone_nr: string;
	groups: (CreateGroup | UpdateGroup)[];
}

//do not touch this "formdata" interface
export interface CreateAccountFormData {
	id: string;
	type: "create" | "update";
	name: string;
	orgnr: string;
	contactPerson: string;
	email: string;
	phone: string;
	error: string | null;
}
